import { EAnimalTypes, EAnimalTypesUI } from './Animal.types';
import { TOptionType, TOptionTypeUi } from './GeneralTypes';

export enum EAnimalInfoConfig {
  ANIMAL_PHOTO = 'ANIMAL_PHOTO',
  ANIMAL_BIRTHDAY = 'ANIMAL_BIRTHDAY',
  ANIMAL_SPECIES = 'ANIMAL_SPECIES',
  ANIMAL_BREED = 'ANIMAL_BREED',
  ANIMAL_GENDER = 'ANIMAL_GENDER',
  ANIMAL_COLOR = 'ANIMAL_COLOR',
  ANIMAL_WEIGHT = 'ANIMAL_WEIGHT',
  MICROCHIP_NUMBER = 'MICROCHIP_NUMBER',
  SPAYED_NEUTERED = 'SPAYED_NEUTERED',
  HOUSE_TRAINED = 'HOUSE_TRAINED',
  HISTORY_OF_AGGRESSION = 'HISTORY_OF_AGGRESSION',
}

export type TPropertyConfigNoteDB = {
  id?: string;
  title: string | null;
  description: string;
};
export type TPropertyConfigNoteUI = {
  id?: string;
  title: string;
  description: string;
};

export type TPropertyConfigEditNoteUI = {
  animalRequirementsSetId: string;
  note: TPropertyConfigNoteUI;
  name?: string;
  propertyId?: string;
};

export type TPropertyConfigEditNoteDB = {
  animalVerificationConfigurationId: string;
  note: TPropertyConfigNoteDB;
  newConfigurationSetName?: string;
  propertyId?: string;
};

export type TPropertyWithAccessibilityInfoDB = {
  id: string;
  name: string;
  beneficiaryUserHasAccessToProperty: boolean;
};
export type TPropertyWithAccessibilityInfoUI = {
  id: string;
  name: string;
  beneficiaryUserHasAccessToProperty: boolean;
};

export type TPropertyConfigSetPetRestrictionsUI = {
  breeds: TOptionTypeUi[] | null;
  species: TOptionTypeUi[] | null;
  maxWeightLimit?: number | null;
  maxNumberOfPets?: number | null;
  isPetAllowed?: string;
};
// TODO: align with BE
export type TPropertyConfigSetPetRestrictionsDB = {
  restrictedBreeds: TOptionType[] | null;
  allowedSpecies: TOptionType[] | null;
  maxPetWeight: number | null;
  maxNumOfPetsAllowed: number | null;
  noPetPolicy?: boolean;
};

// TODO: align with BE
export enum ERequiredDocument {
  RABIES_VACCINATION = 'RABIES',
  CITY_LICENSE = 'CITY_LICENSING',
  SPAYED_NEUTERED_DOCUMENT = 'SPAYED_NEUTERED',
  DOG_BITE_LIABILITY_INSURANCE = 'DOG_LIABILITY_INSURANCE',
  PARVO = 'PARVO',
}

export type TSpeciesRequirementUI = {
  dog: boolean;
  cat: boolean;
};
// TODO: align with BE
export enum ESpeciesRequirementDB {
  DOG = 'DOG',
  CAT = 'CAT',
}

export type TRequiredDocumentsUI = {
  [key in ERequiredDocument]?: boolean | TSpeciesRequirementUI;
};

export type TCustomRequiredDocumentUI = {
  id: string; // generated in FE for editing/deleting
  name: string;
  hasExpirationDate: 'yes' | 'no';
  requiredSpecies: TSpeciesRequirementUI;
  requiredAnimalTypes: EAnimalTypesUI[];
};

export type TRequiredVetDocumentsUI = {
  expirable: boolean;
  name: string;
  applicableSpecies: TSpeciesRequirementUI;
  requiredAnimalTypes?: EAnimalTypesUI[];
  predefined: boolean;
};

export type TRequiredDocumentsDB = {
  expirable: boolean;
  name: string;
  applicableSpecies: ESpeciesRequirementDB[];

  applicableAnimalTypes?: EAnimalTypesUI[];
  predefined: boolean;
};
// TODO: align with BE
export type TCustomRequiredDocumentDB = {
  id: string;
  name: string;
  hasExpirationDate: boolean;
  requiredSpecies: ESpeciesRequirementDB[] | null;
  requiredAnimalTypes: EAnimalTypes[] | null;
};

export type TPropertyConfigSetGetUI = {
  id: string;
  name: string;
  requirements: EAnimalInfoConfig[];
  notes: TPropertyConfigNoteDB[];
  isDefault?: boolean;
  properties?: TPropertyWithAccessibilityInfoDB[];
  tenantShouldPayForPet: boolean;
  petRestrictions?: TPropertyConfigSetPetRestrictionsUI;
  requiredDocuments?: TRequiredDocumentsUI;
  customRequiredDocuments?: TCustomRequiredDocumentUI[];
};

export type TPropertyConfigSetGetDB = {
  id: string;
  name: string;
  requirements: EAnimalInfoConfig[];
  notes: TPropertyConfigNoteDB[];
  isDefault?: boolean;
  properties?: TPropertyWithAccessibilityInfoDB[];
  tenantShouldPayForPet: boolean;
  petRestrictions: TPropertyConfigSetPetRestrictionsDB | null; // TODO: align with BE
  requiredVetRecords: TRequiredDocumentsDB[] | null; // TODO: align with BE
};

export type TPropertyConfigSetCreateUI = {
  propertyIds: string[];
  notes?: TPropertyConfigNoteUI[];
  animalRequirements: EAnimalInfoConfig[];
  name: string;
  requiredDocuments: TCustomRequiredDocumentUI[];
  isPetAllowed: string;
  maxPets: number;
  maxPetWeight: number;
  // TODO: add petRestrictions
  // TODO: add requiredDocuments
  // TODO: add customRequiredDocuments
};

export type TPropertyConfigSetCreateDB = {
  propertyIds: string[];
  notes?: TPropertyConfigNoteDB[];
  animalVerificationCriteria: EAnimalInfoConfig[];
  name: string;
  noPetPolicy?: boolean;
  petRestrictions: TPropertyConfigSetPetRestrictionsDB | null;
  requiredVetRecords: TRequiredDocumentsDB[];
  // TODO: add petRestrictions
  // TODO: add requiredDocuments
  // TODO: add customRequiredDocuments
};

export type TCustomRequiredDocumentsUI = {
  hasExpirationDate: 'yes' | 'no';
  id: string;
  name: string;
  requiredAnimalTypes: string[];
  requiredSpecies: boolean | TSpeciesRequirementUI;
};

export type TPropertyConfigSetEditUI = {
  id: string;
  requirements: EAnimalInfoConfig[];
  name: string;
  newAssignedPropertyIds?: string[];
  unassignedPropertyIds?: string[];
  replacingAnimalVerificationConfigurationId?: string;

  isPetAllowed: 'no' | 'yes';
  maxPets?: number;
  maxPetWeight?: number;
  restrictedBreeds?: TOptionTypeUi[];
  species?: TOptionTypeUi[];
  requiredDocuments: TRequiredDocumentsUI;
  customRequiredDocuments: TCustomRequiredDocumentsUI[];
};
export type TPropertyConfigSetEditDB = {
  animalVerificationConfigurationId: string;
  criteria: EAnimalInfoConfig[];
  name: string;
  replacingAnimalVerificationConfigurationId?: string;
  newlyAssignedProperties?: string[];
  newlyUnassignedProperties?: string[];
  // TODO: add petRestrictions
  noPetPolicy: boolean;
  petRestrictions?: {
    maxNumOfPetsAllowed?: number;
    maxPetWeight?: number;
    restrictedBreeds?: string[];
    allowedSpecies?: string[];
  };
  requiredVetRecords: TRequiredDocumentsDB[];
};
